import { ref } from 'vue';
import { httpService } from '../services/httpService';
import { log, error as logError } from '../utils/DebugLogger';

import '../contracts/Orders_ItemDetailResponse';

/**
 * Composable for fetching a single enriched SO order item
 * via the new /so/orders/item/{id} endpoint.
 */
export function useSOOrderItemDetail() {
  const isLoading = ref(false);
  const error = ref(null);
  const basePath = '/index.php/so/orders';

  /**
   * Fetch a single enriched order item with children and work-order summary.
   */
  const fetchItem = async (itemId: number) => {
    log('useSOOrderItemDetail', 'fetchItem', 'Fetching order item', { itemId });
    isLoading.value = true;
    error.value = null;
    try {
      const response = await httpService.get(`${basePath}/item/${itemId}`, { responseContract: 'Orders_ItemDetailResponse' });
      if (response.success) {
        return response.dados;
      }
      throw new Error(response.error || 'Erro ao buscar item');
    } catch (err) {
      logError('useSOOrderItemDetail', 'fetchItem', 'Error', err);
      error.value = err.message;
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    error,
    fetchItem,
  };
}
